import styled from 'styled-components'

import { helpers } from '../../../../styles/theme'
import { Item } from './Item'

type Props = {
	isHighlighted: boolean
	isSelected: boolean
	isDisabled: boolean
	isSmall: boolean
}

export const ItemContent = styled.div<Props>`
	background-color: ${({ isHighlighted, isDisabled, isSelected }) => {
		if (isHighlighted)
			return isDisabled
				? helpers.color.input.menuOptionBackgroundHighlightedDisabled
				: helpers.color.input.menuOptionBackgroundHighlighted
		if (isSelected)
			return isDisabled
				? helpers.color.input.menuOptionBackgroundSelectedDisabled
				: helpers.color.input.menuOptionBackgroundSelected
		return isDisabled ? helpers.color.input.menuOptionBackgroundDisabled : helpers.color.input.menuOptionBackground
	}};
	display: flex;
	padding: ${({ isSmall }) => (isSmall ? '4px 6px' : '8px 10px')};
	border-radius: 4px;
	transition: background-color 80ms ease;
	align-items: center;
	justify-content: space-between;
	column-gap: 6px;

	${Item}:hover {
		background-color: ${({ isDisabled }) => (isDisabled ? helpers.color.input.menuOptionBackgroundHoverDisabled : helpers.color.input.menuOptionBackgroundHover)};
	}
`
